import { useMutation } from "@tanstack/react-query"
import { createProject } from "../../../api/projects/createProject"

export const useCreateProject = () => {
  
  return useMutation({
    mutationKey: ["createProject"],
    mutationFn: createProject
  })
}